import type { Invoice } from "../types";
import {
  invoiceShowsDownloadButton,
} from "../invoiceDisplay";

type Props = {
  invoice: Invoice;
  onView: () => void;
};

export default function InvoiceCard({ invoice: inv, onView }: Props) {
  const showDownload = invoiceShowsDownloadButton(inv);

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onView}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onView();
        }
      }}
      className="rounded-2xl overflow-hidden cursor-pointer active:scale-[0.99] transition-all"
      style={{ background: "#fff" }}
    >
      <div className="px-4 pt-4 pb-3" style={{ borderBottom: "1px solid #F5F5F7" }}>
        <div className="flex items-start justify-between gap-2 mb-2">
          <div className="flex items-center gap-2">
            <div
              className="w-9 h-9 flex items-center justify-center rounded-xl"
              style={{ background: "#FEF3C7" }}
            >
              <i className="ri-receipt-line" style={{ color: "#D97706", fontSize: 18 }} />
            </div>
            <div>
              <div className="text-sm font-bold text-gray-900">{inv.title}</div>
              <div className="text-xs text-gray-400 mt-0.5">{inv.id}</div>
            </div>
          </div>
          <span
            className="text-xs font-semibold px-2.5 py-1 rounded-full flex-shrink-0"
            style={{ background: inv.statusBg, color: inv.statusColor }}
          >
            {inv.status}
          </span>
        </div>
        <div className="flex items-center gap-3 text-xs text-gray-400">
          <span>
            <i className="ri-calendar-line mr-1" style={{ fontSize: 11 }} />
            {inv.date}
          </span>
          <span>{inv.type}</span>
        </div>
      </div>
      <div className="px-4 py-3 flex items-center justify-between">
        <div>
          <div className="text-xs text-gray-400 mb-0.5">发票金额</div>
          <div className="text-lg font-bold" style={{ color: "#EF4444" }}>
            ¥
            {inv.amount.toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </div>
        </div>
        <div className="flex gap-2">
          {showDownload ? (
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                if (inv.invoiceUrl) {
                  window.open(inv.invoiceUrl, "_blank", "noopener,noreferrer");
                }
              }}
              className="px-3 py-1.5 rounded-full text-xs cursor-pointer whitespace-nowrap"
              style={{ background: "#F5F5F5", color: "#6B7280" }}
            >
              <i className="ri-download-2-line mr-1" style={{ fontSize: 11 }} />
              下载
            </button>
          ) : null}
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              onView();
            }}
            className="px-3 py-1.5 rounded-full text-xs font-semibold cursor-pointer whitespace-nowrap text-white active:scale-95 transition-all"
            style={{ background: "linear-gradient(135deg,#D97706,#F59E0B)" }}
          >
            查看发票
          </button>
        </div>
      </div>
    </div>
  );
}
